package pl.decks.chartjs.style

sealed class ChartLabel {
    data class Single(val text: String) : ChartLabel()
    data class MultiLine(val lines: List<String>) : ChartLabel()

    fun toChartJs(): dynamic = when (this) {
        is Single -> text.asDynamic()
        is MultiLine -> lines.toTypedArray().asDynamic()
    }
    companion object {
        operator fun invoke(text: String): Single = Single(text)
        operator fun invoke(multiLineText: List<String>): MultiLine = MultiLine(multiLineText)
    }
}
